




















































import { filter, IterateeShorthand, orderBy, maxBy } from 'lodash'
import { mapActions } from 'vuex'

import { RunningProcess, Process, ProcessLog, ProcessDetail } from '@/store/workflow/types'
import Provide from '@/components/Provide'

import Vue from 'vue'
export default Vue.extend({
  components: { Provide },
  computed: {
    filters(): ProcessDetail {
      let filter = {} as ProcessDetail
      filter.log = {} as ProcessLog

      if (this.name && filter.log) {
        filter.log.business_key = this.name
      }
      if (this.inProcess && filter.log) {
        filter.log.super_instance_id = this.inProcess.id
      }
      if (this.flowchart && filter.log) {
        filter.log.definition_key = this.flowchart
      }
      if (this.onlyActive && filter) {
        filter.log.end_time = null
      }

      // filter by current case id
      if (filter.log) {
        filter.log.case_id = this.case ? this.case : this.$store.getters.currentCaseId
      }
      return filter
    },
    processDetails(): ProcessDetail[] {
      return this.$store.getters['workflow/processDetails']
    },
    filteredProcessDetails(): any[] {
      const details = filter(this.processDetails, this.filters)
      if (this.onlyLatest) {
        const latest = maxBy(details, 'log.start_time')
        if (latest) {
          return [latest]
        } else {
          return []
        }
      } else {
        return orderBy(details, 'log.start_time', 'asc')
      }
    },
  },
  methods: {
    ...mapActions('workflow', ['cancelProcess', 'startProcess', 'sendMessage']),
  },
  inject: {
    process: {
      default: null,
    },
  },
  props: {
    case: {
      type: String,
    },
    name: {
      type: String,
    },
    flowchart: {
      type: String,
    },
    onlyLatest: {
      type: Boolean,
      default: false,
    },
    onlyActive: {
      type: Boolean,
      default: false,
    },
    inProcess: {
      type: Object as () => Process,
      default(): Process | null {
        return (this as any).process
      },
    },
  },
})
